import { render } from "./CartModel.vue?vue&type=template&id=49cf970a&scoped=true"
import script from "./CartModel.vue?vue&type=script&lang=js"
export * from "./CartModel.vue?vue&type=script&lang=js"

import "./CartModel.vue?vue&type=style&index=0&id=49cf970a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-49cf970a"

export default script